<div class="all-page-combo-layout">
  <div class="all-page-feed">

    <div class="hpanel">

      <div class="panel-heading hbuilt">
        <label class="control-label padding-top-0 margin-bottom-5 margin-top-5">About</label>
        <div class="panel-tools">
          <div class="pull-right btn-group">
            <div class="col-sm-2" title="Edit about company" *ngIf="ownerFlag" (click)="editBasic(basicTemplate)">
              <button class="edit-pencil">
                <span>
                  <ng-icon name="tablerPencil" class="editBG icon-over"></ng-icon>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loadAPIcall" class="panel-body break-word">
        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1"
          [NameOftheScreen]="'candidateDetails'"></app-common-skeleton>
      </div>
      <div *ngIf="!loadAPIcall" class="panel-body break-word">
        <div class="row form-group">
          <div class="col-sm-3">Network Name : </div>
          <div class="col-sm-9">
            {{pesponseDisplay?.networkName }}
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">Description :</div>
          <div class="col-sm-9">
            <div *ngIf="pesponseDisplay?.description;else erg" [ngxSummernoteView]="pesponseDisplay?.description">
            </div>
            <ng-template #erg>Not provided</ng-template>
          </div>
          <ng-template #erg>Not provided</ng-template>
        </div>
      </div>
    </div>
  </div>


  <div class="all-page-widget">
    <app-common-widget [page]="'NETWORK_ABOUT_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
  </div>
</div>
<ng-template #basicTemplate>

  <div class="common-header-flex">
    <div>Network Details</div>
    <button>
      <span class="common-close" (click)="close()">&times;</span>
    </button>
  </div>

  <div class="panel-body">
    <form [formGroup]="networkModalForm" class="app-form form-horizontal">
      <div class="app-form">
        <div class="form-group row ">
          <div class="col-md-4" style="display: grid;">
            <label for="networkName" class=" control-label required-field font-light">Network Name</label>
          </div>

          <div class="col-md-7">
            <input maxlength="31" type="text" class="form-control input-sm" placeholder="Network Name"
              formControlName="networkName" trim="blur" />
            <div
              *ngIf="(submit && f.networkName.invalid) || (f.networkName.invalid && (f.networkName.dirty || f.networkName.touched))"
              class="error-msg">
              <div class="red" *ngIf="f.networkName.errors?.pattern">Name must contain alphabet only</div>
              <div class="red" *ngIf="f.networkName.errors?.required">Network name is required</div>
              <div class="red" *ngIf="f.networkName.errors?.minLetters">Minimum 5 chars required</div>
              <div class="red" *ngIf="f.networkName.errors?.maxLetters">Maximum 30 chars allowed</div>
            </div>
          </div>
        </div>



        <div class="form-group row ">
          <div class="col-md-4" style="display: grid;">
            <label for="networkName" class=" control-label   font-light"> Network Logo </label>
          </div>

          <div class="col-md-7">
            <input type="file" class="form-control input-sm" accept=".jpg, .jpeg, .png" #myFileInput id="myFileInput"
              (change)="fileChangeEventlogo($event, template)" (click)="resetFileId()" />

          </div>
        </div>

        <div class="form-group row ">
          <div class="col-md-4" style="display: grid;">
            <label for="networkName" class=" control-label   font-light"> Network Banner Image</label>
          </div>

          <div class="col-md-7">
            <input type="file" class="form-control input-sm" accept=".jpg, .jpeg, .png" #myFileInputbanner
              id="myFileInputbanner" (change)="fileChangeEventBanner($event, templatebanner)"
              (click)="resetFileBanner()" />

          </div>
        </div>


        <div class="form-group row  R-summary">
          <div class="col-md-4" style="display: grid;">
            <label for="networkName" class=" control-label  font-light">Description</label>
          </div>
          <div class="col-md-7">
            <textarea class="form-control input-sm" placeholder="Description" formControlName="description"
              [ngxSummernote]="config" name="" id="" cols="30" rows="4"></textarea>
            <div class="error-msg" *ngIf="f.description.invalid ">
              <!-- <div *ngIf="f.description.errors.minchar ">
                {{FORMERROR.ABOUT_YOUR_MIN}}
              </div> -->
              <div *ngIf="f.description.errors.maxchar">
                {{FORMERROR.ABOUT_YOURSELF_MAX}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
        <button type="button" class="btn primary-btn" [disabled]="!networkModalForm.valid"
          (click)="submit()">Submit</button>
      </div>
    </div>
  </div>

</ng-template>


<ng-template #template>

  <div class="common-header-flex">
    <div>Network Logo</div>
    <button>
      <span (click)="closePhoto()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" format="jpeg"
      (imageCropped)="imageCropped($event)"></image-cropper>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="closePhoto()">Cancel</button>
        <button class="btn  btn-primary " (click)="imageLoaded()">Apply</button>
      </div>
    </div>
  </div>

</ng-template>



<ng-template #templatebanner>
  <!-- <button type="button" style="font-size: 31px; padding-right: 17px; padding-top: 7px" class="close pull-right"
    aria-label="Close" (click)="closePhoto()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h5 style="margin: 10px 10px 10px 10px; padding-top: 10px"> Network Banner Image </h5>
  <hr /> -->

  <div class="common-header-flex">
    <div>Network Banner</div>
    <button>
      <span (click)="closePhoto()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4.5 / 1"
      format="jpeg" (imageCropped)="imageCroppedBanner($event)"></image-cropper>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="closePhoto()">Cancel</button>
        <button class="btn btn-primary" (click)="imageLoadedBanner()">Apply</button>
      </div>
    </div>
  </div>

</ng-template>
